/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-09-05 19:54:43
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyUtils } from '../../utils/Utils';
import BsyDatePicker from '../BsyDatePicker';
import BsyMsgBubble from '../BsyMsgBubble';
import { BsyWidget } from '../BsyWidget';
import './index.css'
import { BsyConfig } from '../../global/BsyConfig';

class BsySubformTextEditor extends BsyWidget {

  static defaultProps = {
    baseCls: "bsy-subform-text",
    onStopEdit: null,

    allowBlank: !0,

  }

  constructor(props) {
    super({
      baseCls: "bsy-subform-text",
      onStopEdit: null,

      allowBlank: !0,
      ...props
    });

    this.element = React.createRef();
  }

  getValue = () => {
    const { value } = this.state
    return value
  }

  componentDidMount() {
    super.componentDidMount()

  }

  getAddressContext = (context) => {
    this.context = context
  }

  _onTriggerClick = (event) => {
    const { regex } = this.options;

    let that = this;

    if (that.showMsg) {
      return;
    }

    let constregex = BsyConfig().CONST.TEXT_TYPE_REGEXP;
    let format = "HH:mm:ss"
    if (regex === constregex.HMS) {
      format = "HH:mm:ss"
    } else if (regex === constregex.HM) {
      format = "HH:mm"
    }
    let val = this.state.value;
    if (val) {
      let TODAY = new Date();
      val = TODAY.getFullYear() + "/" + (TODAY.getMonth() + 1) + "/" + TODAY.getDate() + " " + this.state.value;
    } else {
      val = new Date();
    }
    let checksss = new Date(val);
    if (checksss instanceof Date && isNaN(checksss.getTime())) {
      checksss = new Date();
    }

    BsyMsgBubble({
      anchor: event.currentTarget,
      contentHTML: (ref) => {
        that.showMsg = ref;
        return <BsyDatePicker
          // startDate={that.std}
          // endDate={that.edd}
          format={format}
          date={checksss}
          onDateUpdate={(c, closeFloat) => {
            that.value = null;
            let Hours = c.getHours();
            Hours = Hours < 10 ? ('0' + Hours) : Hours
            let Minutes = c.getMinutes();
            Minutes = Minutes < 10 ? ('0' + Minutes) : Minutes
            let Seconds = c.getSeconds();
            Seconds = Seconds < 10 ? ('0' + Seconds) : Seconds
            if (c) {
              if (regex == constregex.HMS) {
                that.value = `${Hours}:${Minutes}:${Seconds}`
              } else if (regex === constregex.HM) {
                that.value = `${Hours}:${Minutes}`
              }
            }

            that.setState({ value: that.value }, () => {
              if (closeFloat)
                ref.closeAlter()
            });

          }}

          onDateClear={() => {
            that.value = null
            that.setState({ value: null }, () => {
              ref.closeAlter()
            });
          }}

        />
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: "auto",
      width: 'auto',
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function () {
        that.showMsg = null;
        BsyUtils.applyFunc(that, that.props.onStopEdit, [that.value, null, that], !1)
        return !1;
      }
    })
  }

  render() {

    const { cssName, format } = this.options

    return (
      <div className={cssName}
        ref={this.element}
        onClick={(e) => {
          this._onTriggerClick(e)
        }}
      >
        {
          this.value
        }
      </div>
    );
  }
}

export default BsySubformTextEditor;